<template>
  <div class="passengers-info">
    <passenger-form
      v-for="(passenger, passenger_index) in passengers"
      :key="`pax_${passenger_index}`"
      :passenger="passenger"
      :passenger_index="passenger_index"
      :expanded="is_expanded(passenger_key(passenger, passenger_index))"
      @toggle="toggle_expanded(passenger_key(passenger, passenger_index))"
    />
  </div>
</template>

<script>
import PassengerForm from "./passenger-form.vue";

export default {
  name: "passengers-info",
  components: {
    "passenger-form": PassengerForm,
  },
  props: {
    passengers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tab_state: "{}",
    };
  },
  computed: {
    open_tabs: {
      get() {
        try {
          return JSON.parse(this.tab_state);
        } catch (e) {
          this.log(e);
          return {};
        }
      },
      set(value) {
        this.tab_state = JSON.stringify(value);
      },
    },
  },
  created() {
    const [first_passenger] = this.passengers;
    if (!first_passenger) return;
    this.open_tabs = { [this.passenger_key(first_passenger, 0)]: true };
  },
  methods: {
    passenger_key(passenger, passenger_index) {
      const { id } = passenger || {};
      return String(id !== undefined && id !== null ? id : passenger_index);
    },
    is_expanded(key) {
      return !!this.open_tabs[key];
    },
    toggle_expanded(key) {
      const was_open = this.open_tabs[key];
      const open_tabs = {};
      open_tabs[key] = !was_open;
      this.open_tabs = open_tabs;
    },
  },
};
</script>

<style lang="scss" scoped>
.passengers-info {
  display: flex;
  flex-direction: column;

  ::v-deep .passenger-form:first-child {
    padding-top: 0;
  }
}
</style>
